/* import __COLOCATED_TEMPLATE__ from './future-date-input-selector-row.hbs.js'; */
import { classNames } from "@ember-decorators/component";
import SelectKitRowComponent from "select-kit/components/select-kit/select-kit-row";
const FutureDateInputSelectorRow = dt7948.c(class FutureDateInputSelectorRow extends SelectKitRowComponent {}, [classNames("future-date-input-selector-row")]);
export default FutureDateInputSelectorRow;